module.exports = __webpack_public_path__ + "static/custom_coin-0c85f42fecf0bb96ba8dad11842682fd.png";